import { FC } from 'react';
import { QuiltsResponseMega } from '../../../../api/http-client/types';
import WithTooltipWrap from '../WithTooltipWrap';
import styles from '../../styles.module.scss';
import { isVac } from 'utilities/is-vac';

interface CarouselItemTypeModel {
  isStub?: boolean;
  item?: QuiltsResponseMega;
}

export const CarouselItemType: FC<CarouselItemTypeModel> = ({ isStub, item }) => {
  return isStub ? (
    <div className={styles.carousel__content_item}></div>
  ) : (
    <>
      {item ? (
        <WithTooltipWrap
          children={
            isVac() ? (
              <div className={styles.carousel__content_item}>
                {item?.finalImage?.small ? (
                  <img
                    src={item.finalImage.small}
                    alt={
                      item?.name ||
                      (item?.firstName && item?.lastName
                        ? `${item.firstName} ${item.lastName}`
                        : 'person-icon')
                    }
                  />
                ) : (
                  <div className={styles.carousel__content_empty}>
                      <img
                        src={'/img/general/dummy-person.jpg'}
                        alt={
                          item?.name ||
                          (item?.firstName && item?.lastName
                            ? `${item.firstName} ${item.lastName}`
                            : 'person-icon')
                        }
                      />
                  </div>
                )}
              </div>
            ) : (
              <div className={styles.carousel__content_item1}>
                <div className={styles.carousel__content_item1Border}></div>
                <img
                  className={styles.carousel__content_item1Img}
                  src={item?.finalImage?.small || '/img/general/dummy-person.jpg'}
                  alt={
                    item?.name ||
                    (item?.firstName && item?.lastName
                      ? `${item.firstName} ${item.lastName}`
                      : 'person-icon')
                  }
                />
              </div>
            )
          }
          id={item.id}
          url={item.finalImage?.medium || '/img/general/dummy-person.png'}
          name={item.name || `${item.firstName} ${item.lastName}`}
          dateOfBirth={item.dateOfBirth?.year || 1960}
          dateOfPassing={item.dateOfPassing?.year || 1960}
          isDeceased={item.isDeceased}
        ></WithTooltipWrap>
      ) : (
        <div className={styles.carousel__content_item}></div>
      )}
    </>
  );
};
